export default __webpack_public_path__ + "static/media/diary-mobile-3.bc096229.png";